import { rocketIntegrationLogger } from './logger';

const logger = rocketIntegrationLogger;

// TYPES

export type WindowEventListener = (this: Window, ev: MessageEvent<unknown>) => unknown;

export type ExpectedRequestFieldValues = {
  name: string;
  [key: string]: unknown;
};

export type RiRequest = {
  name: string;
  requestId: string;
  [key: string]: unknown;
};

export type RiResponse = {
  requestId: string;
  [key: string]: unknown;
};

export type RiMessage =
  | {
      to: 'rocket' | 'listmanager';
      from: 'rocket' | 'listmanager';
      request: RiRequest;
    }
  | {
      to: 'rocket' | 'listmanager';
      from: 'rocket' | 'listmanager';
      response: RiResponse;
    };

// GUARDS

/** Type guard for RiRequest */
export function isRiRequest(obj: unknown): obj is RiRequest {
  if (!obj || typeof obj !== 'object') return false;
  if (!('name' in obj) || !obj.name) {
    logger.error('request was missing a name', obj);
    return false;
  }
  if (!('requestId' in obj) || !obj.requestId) {
    logger.error('request was missing a requestId', obj);
    return false;
  }
  return true;
}

/** Type guard for RiResponse */
export function isRiResponse(obj: unknown): obj is RiResponse {
  if (!obj || typeof obj !== 'object') return false;
  if (!('requestId' in obj) || !obj.requestId) {
    logger.error('Response was missing a requestId', obj);
    return false;
  }
  return true;
}
